export default __webpack_public_path__ + "static/media/img2.2fb47bc7.PNG";